import React from 'react';

import { IIconProps, TIconType } from '../interface';

const PlusIcon: TIconType = (props?: IIconProps) => {
	return (
		<svg
			data-id='icon-button'
			data-testid='plus'
			fill='none'
			height='24'
			viewBox='0 0 24 24'
			width='24'
			{...props?.innerSvgProps}
		>
			<path
				d='M3.75 12H20.25'
				stroke={props?.color || '#2E2E6B'}
				strokeLinecap='round'
				strokeLinejoin='round'
				strokeWidth='1.5'
			/>
			<path
				d='M12 3.75V20.25'
				stroke={props?.color || '#2E2E6B'}
				strokeLinecap='round'
				strokeLinejoin='round'
				strokeWidth='1.5'
			/>
		</svg>
	);
};

export default PlusIcon;
